import { ClientCacheAction, ClientCacheStateType } from '../context';
import { SET_CLIENT_CACHE } from '../actions/actionTypes';

export default (
  state: ClientCacheStateType,
  action: ClientCacheAction,
): ClientCacheStateType => {
  switch (action.type) {
    case SET_CLIENT_CACHE:
      return {
        ...state,
        clientCache: action.payload,
      };
    default:
      return state;
  }
};
